import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


export class ConfigData {
  production: boolean;
  maxImageSize: number;
  accountLink: string;
  containerName: string;
  // reference for Content type: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  uploadFileContentType: any;
  textMaxLimit: number;
  htmlMaxLimit: number;
}

@Injectable({ providedIn: 'root' })
export class AppConfig {
  data: any;
  constructor(private http: HttpClient) { }

  loadAppConfig(): Promise<void> {
    return this.http
      .get<ConfigData>('assets/config/web.config.json') // Environment variable updated on runtime through pipeline
      .toPromise()
      .then(data => {
        this.data = data;
      },
        error => { // Error
          console.log('Error:', error.message);
        });
  }

  getConfigData(): ConfigData {
    return this.data;
  }
}
